// SYSTEM_ROUTE: /spiritual
import { JournalView } from './JournalView.js';

export function SpiritualScreen() {
  return (
    <JournalView
      stream="spiritual"
      title="Spiritual"
      subtitle="Gratitude, reflection, prayer, and meditation. Grounding for purpose and character — no scoring."
      placeholder="What are you grateful for, or reflecting on today?"
      privacyNote="Private to you."
    />
  );
}
